/**
 * @summary Site logo display helper.
 */

import throttle from 'lodash/throttle';

const wrapper = document.querySelector( '.c-logo' );
const main = document.querySelector( '.c-logo__main' );
const hand = document.querySelector( '.c-logo__hand' );

let handShown = false;

hand.style.display = 'block';
hand.style.height = '1px';

/**
 * @summary Maintains logo layout.
 */
function maintain() {
	const mainRectangle = main.getBoundingClientRect();
	const handRectangle = hand.getBoundingClientRect();

	// Hand is under the main logo
	if ( mainRectangle.left > handRectangle.left ) {

		// Force syncing of height
		wrapper.style.height = `${mainRectangle.height}px`;

		// Hand is already hidden, bail
		if ( ! handShown ) {
			return;
		}

		hand.style.height = '1px';
		hand.style.opacity = 0;
		handShown = false;
	} else if ( ! handShown ) {

		// Reset styles
		wrapper.style.height = '';
		hand.style.height = '';
		hand.style.opacity = 1;

		handShown = true;
	}
}

setTimeout( maintain, 0 );
window.addEventListener( 'resize', throttle( maintain, 200 ) );



// WEBPACK FOOTER //
// ./src/js/logo.js